import React, { useState, useEffect } from 'react';
import Background from './../assets/background2.png';
import video from './../assets/bgHome.mp4';

type Props = {

}

function Hero({ }: Props) {

    const [currentTextIndex, setCurrentTextIndex] = useState(0);

    const texts = [
        'Intelligence',
        'Measurement',
        'Technology',
        'Analytics',
        'Insights',
        'Support',
        'Strategy',
        'Planning',
        'Tools',
        'Metrics',
        'Optimization',
        'Performance',
        'Innovation',
        'Effectiveness',
        'Impact',
        'Integration',
        'Alignment',
        'Growth',
        'Benchmarking'
    ];
    
    useEffect(() => {
        const interval = setInterval(() => {
          setCurrentTextIndex((prevIndex) => (prevIndex + 1) % texts.length);
        }, 1500); // Cambia cada 3 segundos
    
        return () => clearInterval(interval); // Limpia el intervalo cuando el componente se desmonta
      }, []);

    return (
        <div className='relative w-screen overflow-hiddenh-auto'> 
            <video src={video} autoPlay loop muted className="w-full h-[620px] md:h-[950px] xl:h-[720px] object-cover" />
            <div className='absolute top-[430px] xl:top-96 left-5 xl:left-14 flex flex-col z-20'>
                <span className='text-neonGreen text-[50px] md:text-[80px] xl:text-[120px] font-bold'>{texts[currentTextIndex]}</span>
                <span className='text-white text-3xl md:text-[40px] xl:text-8xl font-bold'>for Sponsored Events</span>
            </div>
        </div>
    )
}

export default Hero